import { BookingDto } from '@timechef/core/api';
import { ensureDate } from '@timechef/core/utils';
import { addDays, isSameDay } from 'date-fns';
import { Booking, BookingsByPeriod, BookingsPeriodEnum } from './booking.models';

// Do not store this grouping because it changes every day, instead we compute it on the fly when required
export const computeBookings = (today: Date, dtos: BookingDto[], maps: Record<number, any>): BookingsByPeriod[] => {
  const ticketsByPeriod: BookingsByPeriod[] = [
    { period: BookingsPeriodEnum.Today, items: [] },
    { period: BookingsPeriodEnum.Tomorrow, items: [] },
    { period: BookingsPeriodEnum.NextBookings, items: [] },
  ];

  const tomorrow = addDays(today, 1);

  dtos.forEach((booking: Booking) => {
    const date = ensureDate(booking.date);
    booking.calendarId = maps[booking.id];
    if (isSameDay(date, today)) getBookingByPeriod(ticketsByPeriod, BookingsPeriodEnum.Today)!.push(booking);
    else if (isSameDay(date, tomorrow)) getBookingByPeriod(ticketsByPeriod, BookingsPeriodEnum.Tomorrow)!.push(booking);
    else getBookingByPeriod(ticketsByPeriod, BookingsPeriodEnum.NextBookings)!.push(booking);
  });

  return ticketsByPeriod;
};

export const getBookingByPeriod = (tickets: BookingsByPeriod[], period: BookingsPeriodEnum) => tickets.find((x) => x.period === period)?.items;
